import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import RequiredIcon from "../../../../assets/images/required.svg";
// import DatePicker from "react-date-picker";
import moment from "moment";
import axios from "../../../../redux/axios";
import { getRelatives } from "../../../../redux/cart/CartAction";
import "./addrelative.css";
import "./styles.scss";
import { Button } from "react-bootstrap";
import DropDown from "../../../../components/Select";
import { areaValue, cityValue, clearTest } from "../../../../redux/auth/actions";
import { ContentCutOutlined } from "@mui/icons-material";
import Autocomplete from '@mui/material/Autocomplete';

export default function AddRelative(props) {
  const dispatch = useDispatch();
  const { close, errotToast, errotText } = props;
  const user = useSelector((state) => state.auth);
  const [country, setCountry] = useState();
  const [mobileView, setMobileView] = useState(false);
  const [btmSheet, setbtmSheet] = useState(false);
  const [addRelative, setAddRelative] = useState(false);
  const [gender, setGender] = useState();
  // const [areaValue, setAreaValue] = useState();
  // const [cityValue, setCityValue] = useState();

  const [added, setAdded] = useState(false);
  const [nphone, setNphone] = useState();
  const [email, setEmail] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [doorno, setDoorno] = useState();
  const [postcode, setPostcode] = useState();
  const [error, setError] = useState(false);
  const [errName, setErrName] = useState("");
  const [selectedRelative, setSelectedRelative] = useState([]);
  const [myself, setMyself] = useState(false);
  const [date, setDate] = useState("");
  const [genderError, setGenderError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [phoneError1, setPhoneError1] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [address, setAddress] = useState();


  const [city, setcity] = React.useState([]);
  const [area, setArea] = React.useState([]);
  const [areaList, setAreaList] = React.useState([]);
  const [areaVal, setAreaVal] = React.useState()
  const [arValue, setArValue] = React.useState();

  const [cityUuid, setCityUuid] = useState("")
  const [areaUuid, setAreaUuid] = useState("")

  const [city_id, setCity_id] = useState()
  const [area_id, setArea_id] = useState()
  console.log(city_id, area_id, areaUuid, "sdfssdfsdffsdf")


  const allCities = useSelector((state) => state.auth.cities);
  const allAreas = useSelector((state) => state.auth.areas);
  console.log(allCities, allCities, "adadsadsa")



  // useEffect(() => {
  //   let cityId = "";
  //   let areaid = "";

  //   allCities.map((item) => {
  //     console.log((item.name, "sdffsdf"))
  //     console.log(item.name, savedCity.label);
  //     if (item.name === savedCity.label) {
  //       cityId = item._id;
  //     }
  //   });

  //   allAreas.map((item) => {
  //     if (item.name === savedArea.area.label) {
  //       areaid = item._id;
  //     }
  //   });
  // }, [])



  React.useEffect(() => {
    if (allCities) {
      let res = allCities.map((e, i) => {
        return {
          label: e.name, value: e.uuid, id: e._id
        };
      });
      setcity(res);
    }
  }, [allCities]);



  React.useEffect(() => {
    if (allCities) {
      allCities.map((city) => {
        if (city.uuid === cityUuid) {
          setCity_id(city._id)
          setArea_id()
        }
      });
    }
  }, [cityUuid]);





  React.useEffect(() => {
    if (areaList && areaList.length !== 0) {
      let res = areaList.map((e, i) => {
        return { label: e.name, value: e.uuid };
      });
      setArea(res);
    }
  }, [areaList]);


  React.useEffect(() => {
    if (areaList) {
      areaList.map((area) => {
        console.log(area, "setArea_idsetArea_id")
        if (area.uuid === areaUuid) {
          setArea_id(area._id)
        }
      });
    }
  }, [areaList, areaUuid]);



  const handlearea = (e, city) => {
    setArValue('Select Area')
    setAreaVal(city)
    console.log(city, "sdassdfdsa")
    const { value, label, name } = city;
    console.log(name, "dsfasf")
    setCityUuid(value)
    dispatch(cityValue({ value, label }));
    axios
      .get(`${process.env.REACT_APP_API_URL}/uploadDoc/getArea/${value}`)
      .then((res) => setAreaList(res.data));
  };






  const savedArea = useSelector((state) => state.area);
  const savedCity = useSelector((state) => state.city);
  const [countryCode, setCountryCode] = useState("");

  const [countryDialCode, setCountryDialCode] = useState();

  const _onPhoneChange = (value, country, e, formattedValue) => {
    console.log(country, countryDialCode, value, value.length, "wdwqqw")
    // if (countryDialCode === "234" && value.length <= 11) {
    //   setNphone(value);
    //   setCountryDialCode(country.dialCode);
    //   return false;
    // }
    // if (countryDialCode === "91" && nphone.length < 12) {
    //   setNphone(value);
    //   setCountryDialCode(country.dialCode);
    //   return false;
    // }
    setNphone(value);
    setCountryDialCode(country.dialCode);

  };

  const re = /^[A-Za-z]+$/;

  const genderList = ["Male", "Female", "Other",];
  console.log(genderList, "genderList")
  const schema = yup.object().shape({
    firstName: yup.string().required("firstName is required"),
    lastName: yup.string().required("lastName is required"),
    email: yup
      .string()
      .email("Must be a valid email")
      .max(255)
      .required("Email is required"),
    address: yup.string().required("Address Required"),
    postcode: yup.string(),
    doorno: yup.string().required("Door No. Required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((res) => {
        setCountry(res.country_code.toLowerCase());
        setCountryCode(res.country_calling_code);
      })
      .catch((data, status) => {
        console.log("Request failed:", data);
      });
  }, []);

  useEffect(() => {
    if (gender) {
      setGenderError(false);
    }

    if (date) {
      setDobError(false);
    }

    if (nphone && nphone.length > 5) {
      setPhoneError(false);
    }
  }, [nphone, date, gender]);

  const handleSubmitForm = async (data, e) => {
    if (gender) {
      setGenderError(false);
    } else {
      setGenderError(true);
      return false;
    }

    if (date) {
      setDobError(false);
    } else {
      setDobError(true);
      return false;
    }

    if (nphone) {
      setPhoneError(false);
    } else {
      setPhoneError(true);
      return false;
    }

    // if (nphone && nphone.length < 5) {
    //   setErrName("Please Enter Valid Phone Number");
    //   setError(true);
    //   return false;
    // }

    if (countryDialCode === "234" && nphone.length <= 11) {
      errotToast(true);
      errotText("please enter valid 13 digit mobile number with country Code");
      return false;
    }
    if (countryDialCode === "91" && nphone.length < 12) {
      errotToast(true);
      errotText("please enter valid 12 digit mobile number with country Code");
      return false;
    }
    if (nphone.length < 10) {
      errotToast(true);
      errotText("please enter valid phone number");
      return false;
    }









    let addressData = [
      {
        street: address,
        // area: areaValue,
        // city: cityId,
        area: area_id,
        city: city_id,
        door_no: doorno,
        pincode: postcode,
      },
    ];

    const formData = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      full_name: firstName + " " + lastName,
      gender: gender,
      mobile: nphone,
      dob: moment(date).format("YYYY-MM-DD"),
      residential_Address: addressData,
    };

    await axios
      .post(`${process.env.REACT_APP_API_URL}/patient/doctall/`, formData)
      .then((res) => {
        dispatch(getRelatives());
        close();
        setAdded(true);
        e.target.reset();
        reset();
        setAddRelative(false);
        setbtmSheet(false);
      })
      .catch((err) => {
        if (err && err.response) {
          errotToast(true);
          errotText("" + err.response.data);
        }
      });
  };


  const handleselectedArea = (ev, selectedArea) => {
    console.log(selectedArea, "selectedCity")
    setArValue(selectedArea);
    setAreaUuid(selectedArea.value);
    dispatch(areaValue(selectedArea));
  }

  return (
    <>
      <div className="relative-content">
        <div className="add-recipient-conatiner">
          <div>
            <form>
              <div className="addRelative-container-out">
                <div className="header-font">Add New Relative Details</div>
                <div className="form-cls-cont">
                  <div className="left-cont">
                    <div className="label-row">
                      <div className="label">First Name</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div className="input_container">
                      <input
                        type="text"
                        className="input"
                        {...register("firstName")}
                        placeholder="Enter first name"
                        value={lastName}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value) === true
                          ) {
                            setLastName(e.target.value);
                          }
                        }}
                      />
                      <p className="errorFont">{errors.firstName?.message}</p>
                    </div>
                  </div>
                  <div className="right-cont">
                    <div className="label-row">
                      <div className="label">Last Name</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div className="input_container">
                      <input
                        type="text"
                        className="input"
                        {...register("lastName")}
                        placeholder="Enter last name"
                        value={firstName}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            re.test(e.target.value) === true
                          ) {
                            setFirstName(e.target.value);
                          }
                        }}
                      />
                      <p className="errorFont">{errors.lastName?.message}</p>
                    </div>
                  </div>
                </div>

                <div className="form-cls-cont">
                  <div className="left-cont">
                    <div className="label-row">
                      <div className="label">Email Address</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div className="input_container">
                      <input
                        value={email}
                        type="email"
                        className="input"
                        {...register("email")}
                        placeholder="Enter email address"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <p className="errorFont">{errors.email?.message}</p>
                    </div>
                  </div>
                  <div className="right-cont">
                    <div className="label-row">
                      <div className="label">Phone Number</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div style={{ marginTop: "5%" }}>
                      <PhoneInput
                        isValid={(value) => {
                          if (value.toString().startsWith("234") ? value.length <= 12 : value.length < 12 || value.length > 15) {
                            if (value.length >= 4 && value.length <= 12)
                              setPhoneError1(true);
                            return false;
                          } else {
                            setPhoneError1(false);
                            return true;
                          }
                        }}
                        containerClass=""
                        // country={country}
                        country={"ng"}
                        value={nphone}
                        onChange={(value, country, e, formattedValue) => {
                          _onPhoneChange(value, country, e, formattedValue);
                        }}
                        // onChange={setNphone}
                        maxLength={10}
                      />
                      <p className="errorFont">
                        {phoneError ? <>Phone is Required</> : null}
                      </p>
                      <p className="errorFont">
                        {phoneError1 ? (
                          <>Please Enter Valid Phone Number</>
                        ) : null}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="form-cls-cont">
                  {!mobileView && (
                    <div className="left-cont">
                      <div className="label-row" style={{ marginTop: "4%" }}>
                        <div className="label">Date - of - Birth</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <div>
                        <input
                          className="input_container"
                          id="date"
                          type="date"
                          onChange={(e) => setDate(e.target.value)}
                          value={date}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                      <p className="errorFont">
                        {dobError ? <>Dob Required</> : null}
                      </p>
                    </div>
                  )}
                  {mobileView && (
                    <div className="left-cont">
                      <div className="label-row">
                        <div className="label">Date - of - Birth</div>
                        <div className="required-img-cls">
                          <img src={RequiredIcon} alt="RequiredIcon" />
                        </div>
                      </div>
                      <input
                        type="date"
                        className="input_container"
                        onChange={(value) => setDate(value.target.value)}
                        value={date}
                        max={moment().subtract(1, "day").toDate()}
                      ></input>
                      <p className="errorFont">
                        {dobError ? <>Dob Required</> : null}
                      </p>
                    </div>
                  )}
                  <div className="right-cont">
                    <div className="label-row">
                      <div className="label">Gender</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div className="input_container">
                      <DropDown
                        closeCalendar={false}
                        placeholder={"Select Gender"}
                        onChange={(e) => {
                          setGender(e.target.value);
                        }}
                        value={gender}
                        options={genderList}
                      />
                      {genderError && (
                        <p className="errorFont">{"gender is required"}</p>
                      )}
                    </div>
                  </div>
                </div>


                <div className="form-cls-cont">
                  <div className="left-cont">
                    <div className="label-row">
                      <div className="label">City</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div
                    // className="input_container"
                    >
                      {/* <DropDown
                        placeholder={"Select City"}
                        // value={city}
                        onChange={(e) => {
                          handlearea(e.target);
                          setArValue('Select Area');
                          console.log(e, "adasdasdasd")
                        }}

                        options={city && city.length !== 0 ? city : []}
                        // options={city}
                        className="input"
                      /> */}

                      <Autocomplete
                        style={{ width: "98%", }}
                        // className="input"
                        value={areaVal ? areaVal : null}
                        id="grouped-demo"
                        options={city && city.length !== 0 ? city : []}
                        // getOptionLabel={(option) => option.label}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params}
                          // style={{background:"#f7f8fb",}}
                          placeholder={"Select City"}
                        />
                        }
                        onChange={handlearea}

                      />

                      {
                        console.log(city, "sfsdfdsfs")
                      }

                    </div>
                  </div>


                  {/* <div className="form-cls-cont"> */}
                  <div className="right-cont">
                    <div className="label-row">
                      <div className="label">Area</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div
                    //  className="sec"
                    // className="input_container"
                    >
                      {/* <DropDown
                        placeholder={"Select Area"}
                        onChange={(e) => {
                          setArValue(e.target);
                          setAreaUuid(e.target.value);
                          dispatch(areaValue(e.target)
                 
                          );
                          console.log(e.target,"sdfsdfsdf")
                          // props.handleLocationChange();
                        }}
                        value={arValue}
                        setValue={(value) => console.log(value)}
                        options={area && area.length !== 0 ? area : []}
                        className="input"
                      /> */}

                      <Autocomplete
                        style={{ width: "98%" }}
                        // className="input"
                        value={arValue ? arValue : null}
                        id="grouped-demo"
                        options={area && area.length !== 0 ? area : []}
                        // getOptionLabel={(option) => option.label}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params}
                          placeholder={"Select City"}
                        />
                        }
                        onChange={handleselectedArea}

                      />
                    </div>

                  </div>
                  {/* </div> */}




                </div>
                <div className="form-cls-cont">
                  <div className="full_row">
                    <div className="label-row">
                      <div className="label">Address</div>
                      <div className="required-img-cls">
                        <img src={RequiredIcon} alt="RequiredIcon" />
                      </div>
                    </div>
                    <div className="input_container1">
                      <input
                        type="text"
                        className="input"
                        {...register("address")}
                        placeholder="Enter Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                      <p className="errorFont">{errors.address?.message}</p>
                    </div>
                  </div>
                </div>
                <div className="btn_grp">
                  <Button
                    className="addrelativ-btn1"
                    onClick={handleSubmitForm}
                  >
                    Add Relative
                  </Button>
                  <Button className="addrelativ-btn2" onClick={close}>
                    Cancel
                  </Button>
                </div>
              </div>{" "}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
